import { useContext, useEffect } from 'react';
import {
  useFavorites,
  useIsFavoritesLoaded
} from '~/context/common/UserContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { useGetVehicleId } from '~/context/vdp/VehicleContext';
import useGetFavoritesCommon from '~/hooks/common/favorites/useGetFavorites';

export default function useGetFavorites() {
  const { setFavorite } = useContext(UserVehicleContext);
  const favorites = useFavorites();
  const currentVehicleId = useGetVehicleId();
  const isFavoritesLoaded = useIsFavoritesLoaded();

  const currentVehicle = favorites.find(
    vehicle => vehicle.vehicleId === currentVehicleId
  );

  useGetFavoritesCommon();

  useEffect(() => {
    // Reconcile only against a loaded list. Setting the per-vehicle favorite
    // before the list resolves would mark it "loaded" with a stale default and
    // let downstream gates (e.g. the mega-vdp event) fire prematurely.
    if (!isFavoritesLoaded) return;

    setFavorite(
      Boolean(currentVehicle),
      currentVehicle?.subscribeToWIPNotifications
    );
  }, [currentVehicle, isFavoritesLoaded, setFavorite]);
}
